module.exports = __webpack_public_path__ + "img/a1.b3730445.png";